import { FlaskConical } from "lucide-react";

const TITLE = "Separate influence from authority.";
const BODY = "Choose one decision that matters to you. Write down everything influencing the choice: your own judgement, another person's opinion, expectations, fear, obligation, expertise, technology or anything else that matters. Then ask: What information is this influence giving me? How much authority do I want to give it? Notice whether separating those two questions changes the way you approach the decision.";

// Same pre-written experiment for everyone (from the published sample Portrait); never AI-generated.
export const GlimpseExperiment = () => (
  <section className="cg-card p-7 sm:p-8" data-testid="glimpse-experiment">
    <p className="cg-eyebrow mb-2">A taste of the full Portrait</p>
    <h2 className="font-serif text-2xl text-[#F3F4F6] mb-4">Try One Experiment</h2>
    <div className="bg-[#0D0E12] border border-[var(--cg-border)] rounded-xl p-5" style={{ borderTop: "2px solid #A8CBB0" }}>
      <p className="font-mono text-xs mb-2 text-[#A8CBB0] inline-flex items-center gap-2"><FlaskConical className="w-3.5 h-3.5" /> EXPERIMENT 01</p>
      <p className="font-serif text-xl text-[#E8EAEE] mb-2">{TITLE}</p>
      <p className="text-sm text-[#B9BDC7] leading-relaxed">{BODY}</p>
    </div>
    <p className="text-xs text-[#6B7280] mt-4">Your full Authority Portrait includes several experiments connected to your own patterns, plus C³ scenarios.</p>
  </section>
);
